var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3649_391769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "url(#paint0_linear_3649_391769)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72492 10.489C4.89158 9.8473 6.19992 9.30563 7.41658 8.76397C9.51658 7.88063 11.6166 7.00563 13.7499 6.1973C14.1666 6.05563 14.9082 5.9223 14.9832 6.53897C14.9416 7.40563 14.7832 8.2723 14.6666 9.13063C14.3832 11.0306 14.0499 12.9223 13.7249 14.814C13.6166 15.4473 12.8249 15.7723 12.3166 15.364C11.0999 14.5473 9.88325 13.7306 8.68325 12.8973C8.29158 12.4973 8.65825 11.9223 9.00825 11.639C10.0083 10.6556 11.0666 9.81397 12.0166 8.78063C12.2749 8.16397 11.5166 8.68063 11.2666 8.83897C9.89992 9.78063 8.56658 10.7806 7.11658 11.614C6.38325 12.0223 5.51658 11.6723 4.78325 11.4473C4.12492 11.1806 3.15825 10.9056 3.72492 10.489Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3649_391769",
    x1: 12.93,
    y1: 3.16142,
    x2: 6.68001,
    y2: 17.7439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3649_391769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTelegram);
export default __webpack_public_path__ + "static/media/logo_telegram.ce3dfb9ed9a1ffbf5e56abe3a1482270.svg";
export { ForwardRef as ReactComponent };